module.exports = __webpack_public_path__ + "static/media/book-medical.06d574df.svg";